/**
 * NUVI KIDZ — consolidated theme JS (single classic script, no bundler,
 * no ES module imports — matches the sample theme's asset pattern).
 *
 * Sections:
 *   1. Festival data
 *   2. Day / night theme
 *   3. Festival theme + picker
 *   4. Festival visual effects (crackers, snow+tree, moon, petals, confetti, colours)
 *   5. Header (sticky, mega menu, mobile menu)
 *   6. Scroll journey progress bar
 *   7. Announcement bar rotation
 *   8. Hero slider
 *   9. Ajax cart
 *   10. Product form (variant selection)
 *   11. Collection filters / sort
 *   12. Carousels (reviews, category rail)
 */
(function () {
  'use strict';

  /* ======================================================
     1. FESTIVAL DATA
     ====================================================== */
  var FESTIVALS = [
    {
      id: 'diwali', label: 'Diwali', emoji: '🪔',
      dateRanges: [{ startMonth: 10, startDay: 12, endMonth: 11, endDay: 15 }],
      colors: { gold: '#D9A400', peach: '#E9622D', lavender: '#5C1A2E', sage: '#8A4B12' },
      fontDisplay: "'Yeseva One', cursive",
      announcements: ['✨ Diwali Sale — up to 30% off little styles ✨', '🪔 Free gift wrap on every order this Diwali', '✨ Happy Diwali from the NUVI Universe ✨'],
      effect: 'crackers',
    },
    {
      id: 'ganesh-chaturthi', label: 'Ganesh Chaturthi', emoji: '🐘',
      dateRanges: [{ startMonth: 8, startDay: 22, endMonth: 9, endDay: 17 }],
      colors: { gold: '#E8A324', peach: '#D8482A', lavender: '#274E13', sage: '#4C7A2A' },
      fontDisplay: "'Yatra One', cursive",
      announcements: ['🐘 Happy Ganesh Chaturthi from the NUVI Universe 🐘', '🌼 Festive styles have landed — shop the collection', '🐘 Free shipping on orders over ₹999'],
      effect: 'petals',
    },
    {
      id: 'navratri', label: 'Navratri', emoji: '💃',
      dateRanges: [{ startMonth: 9, startDay: 22, endMonth: 10, endDay: 2 }],
      colors: { gold: '#E0A400', peach: '#D6336C', lavender: '#3A1E70', sage: '#0E7C7B' },
      fontDisplay: "'Kalam', cursive",
      announcements: ['💃 Happy Navratri from the NUVI Universe 💃', '🎶 Nine nights of little styles — shop festive wear', '💃 Garba-ready sets, now in store'],
      effect: 'colors',
    },
    {
      id: 'raksha-bandhan', label: 'Raksha Bandhan', emoji: '🎗️',
      dateRanges: [{ startMonth: 8, startDay: 1, endMonth: 8, endDay: 20 }],
      colors: { gold: '#D9A441', peach: '#E0607E', lavender: '#7A2340', sage: '#B9772F' },
      fontDisplay: "'Rozha One', serif",
      announcements: ['🎗️ Happy Raksha Bandhan from the NUVI Universe 🎗️', '💝 Sibling sets now available — shop matching styles', '🎗️ Free gift card with orders over ₹1,499'],
      effect: 'petals',
    },
    {
      id: 'eid', label: 'Eid', emoji: '🌙', autoDetect: false,
      dateRanges: [{ startMonth: 3, startDay: 30, endMonth: 4, endDay: 2 }],
      colors: { gold: '#C9A227', peach: '#1E7A5F', lavender: '#0B3D2E', sage: '#2F8F6B' },
      fontDisplay: "'Katibeh', cursive",
      announcements: ['🌙 Eid Mubarak from the NUVI Universe 🌙', '✨ Eid styles now in store — soft, festive, comfortable', '🌙 Free shipping across India this Eid'],
      effect: 'moon',
    },
    {
      id: 'christmas', label: 'Christmas', emoji: '🎄',
      dateRanges: [{ startMonth: 12, startDay: 1, endMonth: 12, endDay: 26 }],
      colors: { gold: '#C0392B', peach: '#2E7D5B', lavender: '#0F3D2E', sage: '#2E7D5B' },
      fontDisplay: "'Mountains of Christmas', cursive",
      announcements: ['❄️ Happy Holidays from the NUVI Universe ❄️', '🎄 Christmas styles now under the tree', '❄️ Free gift wrap on every order this season'],
      effect: 'snow-tree',
    },
    {
      id: 'holi', label: 'Holi', emoji: '🎨',
      dateRanges: [{ startMonth: 3, startDay: 1, endMonth: 3, endDay: 20 }],
      colors: { gold: '#E94E77', peach: '#3AA6A0', lavender: '#7B4FA6', sage: '#F2B705' },
      fontDisplay: "'Baloo 2', cursive",
      announcements: ['🎉 Happy Holi from the NUVI Universe 🎉', '🎨 Colour-fast festive styles — built for Holi', '🎉 Splash of savings — up to 25% off'],
      effect: 'colors',
    },
    {
      id: 'new-year', label: 'New Year', emoji: '🎆',
      dateRanges: [{ startMonth: 12, startDay: 27, endMonth: 1, endDay: 5 }],
      colors: { gold: '#EAB83D', peach: '#D9C7EA', lavender: '#241B4D', sage: '#9AA38C' },
      fontDisplay: "'Paytone One', sans-serif",
      announcements: ['🎆 Happy New Year from the NUVI Universe 🎆', '✨ New year, new little styles — shop now', '🎆 Ring it in with 20% off new arrivals'],
      effect: 'confetti',
    },
  ];

  var DEFAULT_THEME = { gold: '#EAB83D', peach: '#F2B49A', lavender: '#D9D2E9', sage: '#9AA38C', fontDisplay: "'Baloo 2', cursive" };

  function isDateInRange(month, day, range) {
    var value = month * 100 + day;
    var start = range.startMonth * 100 + range.startDay;
    var end = range.endMonth * 100 + range.endDay;
    if (start <= end) return value >= start && value <= end;
    return value >= start || value <= end;
  }
  function getFestivalFromDate(date) {
    date = date || new Date();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    for (var i = 0; i < FESTIVALS.length; i++) {
      var f = FESTIVALS[i];
      if (f.autoDetect === false) continue;
      for (var j = 0; j < f.dateRanges.length; j++) {
        if (isDateInRange(month, day, f.dateRanges[j])) return f;
      }
    }
    return null;
  }
  function findFestival(id) {
    for (var i = 0; i < FESTIVALS.length; i++) if (FESTIVALS[i].id === id) return FESTIVALS[i];
    return null;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ======================================================
     2. DAY / NIGHT THEME
     Purely admin-controlled via Theme settings (nuvi_day_night_override):
     'auto' detects the visitor's local device time; 'day'/'night' locks
     the whole storefront to that mode for every visitor. There is no
     visitor-facing toggle — this is a merchant setting, not a UI control.
     ====================================================== */
  function getModeFromLocalTime(date) {
    var hour = (date || new Date()).getHours();
    return hour >= 6 && hour < 18 ? 'day' : 'night';
  }

  function applyDayNightMode(mode) {
    var root = document.documentElement;
    root.dataset.dayNight = mode;
    if (mode === 'day') {
      root.style.setProperty('--nuvi-bg', 'var(--color-cream)');
      root.style.setProperty('--nuvi-text', 'var(--color-nuvi-green)');
    } else {
      root.style.setProperty('--nuvi-bg', 'var(--color-night-green)');
      root.style.setProperty('--nuvi-text', 'var(--color-moon-cream)');
    }
    document.dispatchEvent(new CustomEvent('nuvi:day-night-change', { detail: { mode: mode } }));
  }

  function initDayNight() {
    var body = document.body;
    if (body.dataset.enableDayNight === 'false') {
      applyDayNightMode('day');
      return;
    }

    var forced = body.dataset.dayNightOverride || 'auto';
    applyDayNightMode(forced === 'auto' ? getModeFromLocalTime() : forced);

    // Auto mode re-checks the visitor's local time periodically (covers a
    // tab left open across the day/night boundary). A forced mode never
    // changes on its own — it stays whatever the merchant set.
    if (forced === 'auto') {
      setInterval(function () {
        applyDayNightMode(getModeFromLocalTime());
      }, 60 * 1000);
    }

    document.addEventListener('visibilitychange', function () {
      document.documentElement.dataset.tabHidden = document.hidden ? 'true' : 'false';
    });
  }

  /* ======================================================
     3. FESTIVAL THEME
     Purely admin-controlled via Theme settings (nuvi_festival_override):
     'auto' detects by today's date; 'none' always uses the regular theme;
     a specific festival id locks that theme on for every visitor. No
     visitor-facing picker — this is a merchant setting, not a UI control.
     ====================================================== */
  function applyFestivalTheme(festival) {
    var root = document.documentElement;
    var theme = festival ? Object.assign({}, DEFAULT_THEME, festival.colors, { fontDisplay: festival.fontDisplay }) : DEFAULT_THEME;
    root.style.setProperty('--nuvi-gold', theme.gold);
    root.style.setProperty('--nuvi-peach', theme.peach);
    root.style.setProperty('--nuvi-lavender', theme.lavender);
    root.style.setProperty('--nuvi-sage', theme.sage);
    root.style.setProperty('--nuvi-font-display', theme.fontDisplay);
    root.dataset.festival = festival ? festival.id : 'none';
    document.dispatchEvent(new CustomEvent('nuvi:festival-change', { detail: { festival: festival } }));
  }

  function resolveActiveFestival(override) {
    if (override === 'none') return null;
    if (!override || override === 'auto') return getFestivalFromDate();
    return findFestival(override);
  }

  function initFestivals() {
    var body = document.body;
    if (body.dataset.enableFestivals === 'false') {
      applyFestivalTheme(null);
      return;
    }

    var forced = body.dataset.festivalOverride || 'auto';
    applyFestivalTheme(resolveActiveFestival(forced));

    // Auto mode re-checks the date periodically (covers a tab left open
    // across midnight, or into/out of a festival window).
    if (forced === 'auto') {
      setInterval(function () {
        applyFestivalTheme(resolveActiveFestival('auto'));
      }, 60 * 1000);
    }
  }

  /* ======================================================
     4. FESTIVAL VISUAL EFFECTS
     ====================================================== */
  var CRACKER_COLORS = ['#FFD98A', '#F6E8CE', '#E9622D', '#D9A400', '#FF6B6B'];
  var CONFETTI_COLORS = ['#EAB83D', '#D9C7EA', '#F2B49A', '#9AA38C', '#FFF9F3', '#FF6B6B'];

  function fxEl(tag, className, styles) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (styles) Object.assign(node.style, styles);
    return node;
  }
  function fxDualShadow(color) {
    return '0 0 10px 3px ' + color + '99, 0 1px 4px rgba(23,45,42,0.45)';
  }
  function fxRandom(min, max) { return min + Math.random() * (max - min); }

  function buildCrackerBurst(x, y, delay, big) {
    var wrap = fxEl('div');
    wrap.style.position = 'absolute';
    wrap.style.left = x + '%';
    wrap.style.top = y + '%';

    wrap.appendChild(fxEl('span', 'fx-flash nuvi-pause-hidden', {
      width: (big ? 70 : 50) + 'px', height: (big ? 70 : 50) + 'px', left: '0', top: '0',
      transform: 'translate(-50%,-50%)',
      background: 'radial-gradient(circle, rgba(255,217,138,0.85), rgba(233,98,45,0.25) 60%, transparent 75%)',
      animationDelay: delay + 's',
    }));

    var sparkCount = big ? 14 : 10;
    var reach = big ? 34 : 24;
    for (var i = 0; i < sparkCount; i++) {
      var angle = (360 / sparkCount) * i;
      var color = CRACKER_COLORS[i % CRACKER_COLORS.length];
      wrap.appendChild(fxEl('span', 'fx-spark nuvi-pause-hidden', {
        width: (big ? 4 : 3) + 'px', height: (big ? 4 : 3) + 'px',
        background: color, boxShadow: fxDualShadow(color),
        transform: 'rotate(' + angle + 'deg) translateY(-' + reach + 'px)',
        animationDelay: delay + 's',
      }));
    }
    return wrap;
  }

  function renderCrackers(container) {
    var bursts = [
      { x: 10, y: 16, delay: 0, big: true }, { x: 82, y: 22, delay: 1.0, big: false },
      { x: 46, y: 10, delay: 2.1, big: true }, { x: 92, y: 46, delay: 0.55, big: false },
      { x: 24, y: 52, delay: 1.6, big: false }, { x: 66, y: 30, delay: 2.7, big: true },
    ];
    bursts.forEach(function (b) { container.appendChild(buildCrackerBurst(b.x, b.y, b.delay, b.big)); });

    var row = fxEl('div', 'fx-diya-row');
    for (var i = 0; i < 5; i++) {
      row.appendChild(fxEl('span', 'fx-diya nuvi-pause-hidden', { animationDelay: (i * 0.28) + 's' }));
    }
    container.appendChild(row);
  }

  function renderFallingParticles(container, effect, festivalColors) {
    var isSnow = effect === 'snow-tree';
    var isPetal = effect === 'petals';
    var count = isSnow ? 34 : isPetal ? 26 : 30;
    var petalPalette = festivalColors ? [festivalColors.peach, festivalColors.gold, festivalColors.sage] : CONFETTI_COLORS;

    for (var i = 0; i < count; i++) {
      var size = isSnow ? fxRandom(4, 7) : isPetal ? fxRandom(11, 17) : fxRandom(6, 10);
      var color = isPetal ? petalPalette[i % petalPalette.length] : CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      var particle = fxEl('span', 'fx-particle nuvi-pause-hidden ' + (isPetal ? 'fx-particle--petal' : isSnow ? '' : 'fx-particle--confetti'), {
        left: fxRandom(0, 100) + '%', top: '-5%',
        width: size + 'px', height: (isPetal ? size * 1.5 : size) + 'px',
        background: isSnow ? '#FFF9F3' : color,
        boxShadow: isSnow ? fxDualShadow('#FFF9F3') : fxDualShadow(color),
        animationDelay: fxRandom(0, 6) + 's', animationDuration: fxRandom(5, 11) + 's',
      });
      particle.style.setProperty('--nuvi-drift', fxRandom(-50, 50) + 'px');
      container.appendChild(particle);
    }
  }

  function renderColorPuffs(container, festivalColors) {
    var puffs = [
      { x: 10, y: 18 }, { x: 28, y: 55 }, { x: 50, y: 12 }, { x: 70, y: 42 },
      { x: 88, y: 20 }, { x: 40, y: 68 }, { x: 60, y: 66 }, { x: 84, y: 60 },
    ];
    var palette = [festivalColors.peach, festivalColors.gold, festivalColors.lavender, festivalColors.sage];
    var isDay = document.documentElement.dataset.dayNight !== 'night';

    puffs.forEach(function (p, i) {
      container.appendChild(fxEl('span', 'fx-puff nuvi-pause-hidden', {
        left: p.x + '%', top: p.y + '%', width: '110px', height: '110px',
        background: palette[i % palette.length], opacity: '0.75',
        mixBlendMode: isDay ? 'multiply' : 'screen', animationDelay: (i * 0.5) + 's',
      }));
    });
  }

  function renderMoonStars(container, festivalColors) {
    for (var i = 0; i < 10; i++) {
      container.appendChild(fxEl('span', 'fx-star nuvi-pause-hidden', {
        left: fxRandom(0, 100) + '%', top: fxRandom(0, 70) + '%', width: '4px', height: '4px',
        background: festivalColors.gold, boxShadow: fxDualShadow(festivalColors.gold),
        animationDelay: fxRandom(0, 3) + 's',
      }));
    }
  }

  function buildChristmasTree(festivalColors) {
    var treeColor = festivalColors.peach, accent = festivalColors.lavender, gold = festivalColors.gold;
    var lights = [
      { x: 38, y: 78, c: gold }, { x: 62, y: 82, c: accent }, { x: 30, y: 60, c: accent },
      { x: 70, y: 58, c: gold }, { x: 42, y: 40, c: gold }, { x: 58, y: 42, c: accent },
    ];
    var lightsMarkup = lights.map(function (l, i) {
      return '<circle cx="' + l.x + '" cy="' + l.y + '" r="2.6" fill="' + l.c + '" class="nuvi-pause-hidden" style="animation:twinkle 3.4s ease-in-out infinite;animation-delay:' + (i * 0.3) + 's;transform-origin:' + l.x + 'px ' + l.y + 'px"/>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.innerHTML = '<svg viewBox="0 0 100 130" class="fx-tree" aria-hidden="true">' +
      '<rect x="45" y="112" width="10" height="14" rx="2" fill="#6B4226"/>' +
      '<polygon points="50,68 22,108 78,108" fill="' + treeColor + '"/>' +
      '<polygon points="50,42 27,82 73,82" fill="' + treeColor + '"/>' +
      '<polygon points="50,16 32,56 68,56" fill="' + treeColor + '"/>' +
      '<path d="M50 2 L53.5 10.5 L62.5 10.5 L55 15.8 L58 24.5 L50 19 L42 24.5 L45 15.8 L37.5 10.5 L46.5 10.5 Z" fill="' + gold + '"/>' +
      lightsMarkup + '</svg>';
    return wrap.firstElementChild;
  }

  function buildEidMoon(festivalColors) {
    var gold = festivalColors.gold, accent = festivalColors.peach;
    var stars = [
      { x: 12, y: 18, s: 3, d: 0 }, { x: 82, y: 12, s: 2.2, d: 0.6 }, { x: 20, y: 62, s: 2.4, d: 1.1 },
      { x: 88, y: 50, s: 3, d: 1.7 }, { x: 6, y: 42, s: 2, d: 2.2 },
    ];
    var starsMarkup = stars.map(function (s) {
      var p = 'M' + s.x + ' ' + (s.y - s.s) + ' L' + (s.x + s.s * 0.3) + ' ' + (s.y - s.s * 0.3) + ' L' + (s.x + s.s) + ' ' + s.y + ' L' + (s.x + s.s * 0.3) + ' ' + (s.y + s.s * 0.3) + ' L' + s.x + ' ' + (s.y + s.s) + ' L' + (s.x - s.s * 0.3) + ' ' + (s.y + s.s * 0.3) + ' L' + (s.x - s.s) + ' ' + s.y + ' L' + (s.x - s.s * 0.3) + ' ' + (s.y - s.s * 0.3) + ' Z';
      return '<path d="' + p + '" fill="' + accent + '" class="nuvi-pause-hidden" style="animation:twinkle 3.4s ease-in-out infinite;animation-delay:' + s.d + 's;transform-origin:' + s.x + 'px ' + s.y + 'px"/>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.style.position = 'relative';
    wrap.style.width = '100%';
    wrap.style.height = '100%';
    wrap.innerHTML = '<span class="fx-moon-glow nuvi-pause-hidden" style="width:6rem;height:6rem;background:radial-gradient(circle, ' + gold + '88, transparent 70%);"></span>' +
      '<svg viewBox="0 0 100 100" class="fx-moon" aria-hidden="true" style="position:relative;">' +
      '<defs><mask id="nuvi-eid-crescent"><rect width="100" height="100" fill="white"/><circle cx="62" cy="38" r="26" fill="black"/></mask></defs>' +
      '<circle cx="48" cy="46" r="30" fill="' + gold + '" mask="url(#nuvi-eid-crescent)"/>' + starsMarkup + '</svg>';
    return wrap;
  }

  function fxClear(container) { if (container) container.innerHTML = ''; }

  function renderFestivalFx(festival) {
    var ambientContainers = document.querySelectorAll('[data-festival-fx="ambient"]');
    var centerpieceContainers = document.querySelectorAll('[data-festival-fx="centerpiece"]');

    ambientContainers.forEach(fxClear);
    centerpieceContainers.forEach(function (c) { fxClear(c); c.hidden = true; });

    if (!festival || document.body.dataset.festivalAnimations === 'false') return;

    ambientContainers.forEach(function (container) {
      switch (festival.effect) {
        case 'crackers': renderCrackers(container); break;
        case 'snow-tree': case 'confetti': case 'petals': renderFallingParticles(container, festival.effect, festival.colors); break;
        case 'colors': renderColorPuffs(container, festival.colors); break;
        case 'moon': renderMoonStars(container, festival.colors); break;
      }
    });

    if (festival.effect === 'snow-tree' || festival.effect === 'moon') {
      centerpieceContainers.forEach(function (container) {
        container.hidden = false;
        container.appendChild(festival.effect === 'snow-tree' ? buildChristmasTree(festival.colors) : buildEidMoon(festival.colors));
      });
    }
  }

  function initFestivalFxListener() {
    document.addEventListener('nuvi:festival-change', function (e) { renderFestivalFx(e.detail.festival); });
  }

  /* ---- global night-time star field ---- */
  function initGlobalStars() {
    var container = document.querySelector('[data-universe-stars]');
    if (!container || document.body.dataset.enableStars === 'false') return;
    var count = Number(document.body.dataset.starDensity || 40);
    for (var i = 0; i < count; i++) {
      container.appendChild(fxEl('span', 'universe-star nuvi-pause-hidden', {
        top: fxRandom(0, 100) + '%', left: fxRandom(0, 100) + '%',
        width: fxRandom(1.5, 3.5) + 'px', height: fxRandom(1.5, 3.5) + 'px',
        animationDelay: fxRandom(0, 3.4) + 's',
      }));
    }
  }

  /* ---- hero-scoped sky decoration (sun/moon/clouds/planets) ---- */
  function initHeroSky() {
    document.querySelectorAll('[data-universe-sky]').forEach(function (sky) {
      var stars = document.createElement('div');
      stars.className = 'nuvi-universe__stars';
      for (var i = 0; i < 16; i++) {
        stars.appendChild(fxEl('span', 'universe-star nuvi-pause-hidden', {
          top: fxRandom(0, 100) + '%', left: fxRandom(0, 100) + '%',
          width: fxRandom(1.5, 3) + 'px', height: fxRandom(1.5, 3) + 'px',
          animationDelay: fxRandom(0, 3.4) + 's',
        }));
      }
      sky.prepend(stars);
    });
  }

  /* ======================================================
     5. HEADER
     ====================================================== */
  /* Pure, side-effect-free — kept separate from initStickyHeader so the
     scroll math can be unit tested without a full DOM/browser. */
  function computeStickyHeaderTop(announceHeight, scrollY) {
    return Math.max(0, announceHeight - scrollY);
  }

  function isPastScrollThreshold(scrollY, threshold) {
    if (typeof threshold !== 'number') threshold = 8;
    return scrollY > threshold;
  }

  function initStickyHeader() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;

    if (header.classList.contains('site-header--static')) {
      var onScrollStatic = function () { header.classList.toggle('is-scrolled', isPastScrollThreshold(window.scrollY)); };
      onScrollStatic();
      window.addEventListener('scroll', onScrollStatic, { passive: true });
      return;
    }

    /* Fixed (not native CSS "sticky") on purpose: sticky positioning
       silently breaks — header stops pinning, mega menu gets clipped —
       the moment any ancestor picks up an overflow/transform/filter rule,
       which is easy to reintroduce by accident anywhere up the tree.
       Driving position via rAF-scroll keeps it correct regardless. */
    document.body.classList.add('has-fixed-header');
    var announce = document.getElementById('AnnouncementBar');
    var ticking = false;

    var setHeaderHeightVar = function () {
      document.documentElement.style.setProperty('--nuvi-header-h', header.offsetHeight + 'px');
    };

    var update = function () {
      var announceH = announce ? announce.offsetHeight : 0;
      var y = window.scrollY || window.pageYOffset || 0;
      header.style.top = computeStickyHeaderTop(announceH, y) + 'px';
      header.classList.toggle('is-scrolled', isPastScrollThreshold(y));
      ticking = false;
    };

    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    setHeaderHeightVar();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setHeaderHeightVar(); update(); });
  }

  function initMegaMenu() {
    var items = document.querySelectorAll('[data-nav-item]');
    items.forEach(function (item) {
      var megaMenu = item.querySelector('[data-mega-menu]');
      if (!megaMenu) return;
      var closeTimer;
      var open = function () {
        clearTimeout(closeTimer);
        items.forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.add('is-open');
      };
      var scheduleClose = function () { closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 150); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (i) { i.classList.remove('is-open'); });
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    if (!menu || !openBtn) return;

    var restartItemAnimations = function (screen) {
      if (!screen) return;
      screen.querySelectorAll('.mobile-menu__item, .mobile-menu__feature').forEach(function (item) {
        item.style.animation = 'none';
        void item.offsetWidth;
        item.style.animation = '';
      });
    };

    var open = function () {
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        restartItemAnimations(menu.querySelector('.mobile-menu__screen.is-active'));
      });
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        menu.hidden = true;
        menu.querySelectorAll('[data-menu-screen]').forEach(function (screen) {
          screen.classList.toggle('is-active', screen.getAttribute('data-menu-screen') === 'root');
          screen.removeAttribute('data-menu-anim');
        });
      }, 500);
    };

    openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    menu.querySelectorAll('a[href]').forEach(function (link) { link.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    menu.querySelectorAll('[data-menu-drill-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetScreen = menu.querySelector('[data-menu-screen="' + trigger.getAttribute('data-menu-drill-open') + '"]');
        var rootScreen = menu.querySelector('[data-menu-screen="root"]');
        if (!targetScreen || !rootScreen) return;
        rootScreen.classList.remove('is-active');
        targetScreen.classList.add('is-active');
        targetScreen.setAttribute('data-menu-anim', 'forward');
        restartItemAnimations(targetScreen);
      });
    });

    menu.querySelectorAll('[data-menu-drill-back]').forEach(function (backBtn) {
      backBtn.addEventListener('click', function () {
        var currentScreen = backBtn.closest('[data-menu-screen]');
        var rootScreen = menu.querySelector('[data-menu-screen="root"]');
        if (!currentScreen || !rootScreen) return;
        currentScreen.classList.remove('is-active');
        rootScreen.classList.add('is-active');
        rootScreen.setAttribute('data-menu-anim', 'back');
        restartItemAnimations(rootScreen);
      });
    });
  }

  function initFooterAccordions() {
    document.querySelectorAll('[data-footer-accordion-trigger]').forEach(function (trigger) {
      var panel = trigger.parentElement.querySelector('[data-footer-accordion-panel]');
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });
  }

  /* ======================================================
     6. SCROLL JOURNEY
     ====================================================== */
  function initScrollJourney() {
    var bar = document.querySelector('[data-scroll-journey]');
    if (!bar) return;
    var fill = bar.querySelector('[data-scroll-fill]');
    var capsule = bar.querySelector('[data-scroll-capsule]');
    var markers = bar.querySelectorAll('[data-pct]');
    var ticking = false;

    var update = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      if (fill) fill.style.width = (pct * 100) + '%';
      if (capsule) capsule.style.left = (pct * 100) + '%';
      markers.forEach(function (m) { m.classList.toggle('is-passed', pct * 100 >= Number(m.dataset.pct)); });
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ======================================================
     7. ANNOUNCEMENT BAR
     ====================================================== */
  function initAnnouncementBar() {
    var bar = document.getElementById('AnnouncementBar');
    if (!bar) return;
    var list = bar.querySelector('[data-announce-list]');
    var prevBtn = bar.querySelector('[data-announce-prev]');
    var nextBtn = bar.querySelector('[data-announce-next]');
    if (!list) return;

    var defaultItemsHtml = Array.prototype.map.call(list.children, function (li) { return li.innerHTML.trim(); });
    var items = defaultItemsHtml;
    var index = 0;
    var timer;
    var isFestival = false;
    var rotateSpeed = Number(bar.dataset.rotateSpeed || 4200) || 4200;

    function renderItems() {
      list.innerHTML = '';
      items.forEach(function (html, i) {
        var li = document.createElement('li');
        li.className = 'announce__item' + (i === 0 ? ' is-active' : '') + (isFestival ? ' is-festival' : '');
        li.innerHTML = html;
        list.appendChild(li);
      });
    }
    function show(i) {
      index = (i + items.length) % items.length;
      Array.prototype.forEach.call(list.children, function (li, idx) { li.classList.toggle('is-active', idx === index); });
    }
    function next() { show(index + 1); }
    function restart() { clearInterval(timer); timer = setInterval(next, rotateSpeed); }

    prevBtn && prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
    nextBtn && nextBtn.addEventListener('click', function () { next(); restart(); });
    restart();

    document.addEventListener('nuvi:festival-change', function (e) {
      var festival = e.detail.festival;
      isFestival = Boolean(festival);
      items = festival && festival.announcements ? festival.announcements : defaultItemsHtml;
      index = 0;
      renderItems();
      restart();
    });
  }

  /* ======================================================
     8. HERO SLIDER
     ====================================================== */
  function initHeroSlider() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var rocket = hero.querySelector('[data-hero-dots] svg');
    var count = slides.length;
    if (count <= 1) return;

    var index = 0;
    var timer;
    var autoplaySpeed = Number(hero.dataset.autoplaySpeed || 5800);

    function show(i) {
      index = (i + count) % count;
      slides.forEach(function (el, idx) { el.classList.toggle('is-active', idx === index); });
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === index); });
      if (rocket) {
        var dotEl = dots[index];
        if (dotEl) rocket.style.left = dotEl.offsetLeft + 'px';
      }
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function restart() { clearInterval(timer); timer = setInterval(next, autoplaySpeed); }

    prevBtn && prevBtn.addEventListener('click', function () { prev(); restart(); });
    nextBtn && nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });

    show(0);
    restart();
  }

  // Clicking anywhere on a hero slide (not just its CTA button) navigates to
  // that slide's link, for every slide that has a button link set.
  function initHeroSlideLinks() {
    var slides = document.querySelectorAll('[data-hero-slide][data-hero-link]');
    if (!slides.length) return;

    slides.forEach(function (slide) {
      var url = slide.dataset.heroLink;
      if (!url) return;

      slide.addEventListener('click', function (e) {
        if (e.target.closest('.hero__cta')) return; // let the real link navigate itself
        window.location.href = url;
      });

      slide.addEventListener('keydown', function (e) {
        if (e.target !== slide) return; // don't hijack Enter on the CTA link itself
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  /* ======================================================
     9. AJAX CART
     ====================================================== */
  var CART_ROUTES = { add: '/cart/add.js', change: '/cart/change.js', get: '/cart.js' };

  function cartLineItemHtml(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">'
      : '<div class="cart-line__placeholder"></div>';
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
    return (
      '<li class="cart-line" data-cart-line data-line-key="' + item.key + '">' +
      '<a href="' + item.url + '" class="cart-line__media">' + img + '</a>' +
      '<div class="cart-line__details">' +
      '<div class="cart-line__row"><div><a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' + variantLine + '</div>' +
      '<button type="button" class="cart-line__remove" data-cart-remove data-line-key="' + item.key + '">Remove</button></div>' +
      '<div class="cart-line__row cart-line__row--bottom">' +
      '<div class="qty-stepper qty-stepper--sm">' +
      '<button type="button" data-cart-qty-decrease data-line-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
      '<span data-cart-qty-value>' + item.quantity + '</span>' +
      '<button type="button" data-cart-qty-increase data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
      '</div><p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p></div>' +
      '</div></li>'
    );
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var total = document.querySelector('[data-cart-total]');
    var discountRow = document.querySelector('[data-cart-discount-row]');
    var discountAmount = document.querySelector('[data-cart-discount-amount]');
    var discountApplied = document.querySelector('[data-cart-discount-applied]');
    var discountTitle = document.querySelector('[data-cart-discount-title]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-hidden', cart.item_count === 0);
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p class="cart-drawer__empty-title">Your bag is empty orbit</p>' +
        '<p class="cart-drawer__empty-text">Add a little something from the universe.</p>' +
        '<a href="/collections/all" class="btn btn--primary" data-cart-close>Explore new in</a></div>';
      if (foot) foot.hidden = true;
    } else {
      body.innerHTML = '<ul class="cart-drawer__list">' + cart.items.map(cartLineItemHtml).join('') + '</ul>';
      if (foot) {
        foot.hidden = false;
        if (total) total.textContent = formatMoney(cart.total_price);

        var hasDiscount = cart.total_discount > 0;
        if (discountRow) discountRow.hidden = !hasDiscount;
        if (discountAmount && hasDiscount) discountAmount.textContent = '−' + formatMoney(cart.total_discount);

        var appliedTitle = cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]
          ? cart.cart_level_discount_applications[0].title
          : (cart.discount_codes && cart.discount_codes[0] ? cart.discount_codes[0].code : null);
        if (discountApplied) discountApplied.hidden = !appliedTitle;
        if (discountTitle && appliedTitle) discountTitle.textContent = appliedTitle;
      }
    }
  }

  function applyDiscountCode(code, redirectPath) {
    code = (code || '').trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath || '/cart');
  }

  function fetchCart() {
    return fetch(CART_ROUTES.get).then(function (r) { return r.json(); });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer) return;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; if (overlay) overlay.hidden = true; }, 350);
  }

  function flyToCart(originEvent) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cartIcon = document.querySelector('[data-cart-icon]');
    if (!cartIcon) return;
    var targetRect = cartIcon.getBoundingClientRect();
    var originX = originEvent && originEvent.clientX ? originEvent.clientX : window.innerWidth / 2;
    var originY = originEvent && originEvent.clientY ? originEvent.clientY : window.innerHeight - 80;

    var dot = document.createElement('div');
    dot.style.cssText = 'position:fixed;z-index:90;left:' + originX + 'px;top:' + originY + 'px;width:14px;height:14px;border-radius:50%;background:var(--nuvi-gold);pointer-events:none;transition:all 0.7s cubic-bezier(0.3,0,0.4,1);opacity:1;';
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      dot.style.left = (targetRect.left + targetRect.width / 2) + 'px';
      dot.style.top = (targetRect.top + targetRect.height / 2) + 'px';
      dot.style.opacity = '0.2';
      dot.style.transform = 'scale(0.4)';
    });
    setTimeout(function () { dot.remove(); }, 750);

    cartIcon.classList.add('is-bouncing');
    setTimeout(function () { cartIcon.classList.remove('is-bouncing'); }, 400);
  }

  var quickAddToastTimer = null;
  function showQuickAddToast() {
    var toast = document.querySelector('[data-quick-add-toast]');
    if (!toast) return;
    clearTimeout(quickAddToastTimer);
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    quickAddToastTimer = setTimeout(hideQuickAddToast, 3000);
  }
  function hideQuickAddToast() {
    var toast = document.querySelector('[data-quick-add-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.hidden = true; }, 250);
  }

  function addToCart(variantId, quantity, originEvent, opts) {
    quantity = quantity || 1;
    opts = opts || {};
    var shouldOpenDrawer = opts.openDrawer !== false;
    var useDrawer = document.documentElement.dataset.cartType !== 'page';
    return fetch(CART_ROUTES.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
        return fetchCart();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (originEvent) flyToCart(originEvent);
        if (!useDrawer) {
          window.location.href = '/cart';
        } else if (shouldOpenDrawer) {
          openCartDrawer();
        } else {
          showQuickAddToast();
        }
        return cart;
      })
      .catch(function (err) {
        alert(err.message || 'Something went wrong adding that to your bag.');
      });
  }

  function changeLineQuantity(key, quantity) {
    return fetch(CART_ROUTES.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function initCart() {
    fetchCart().then(renderCartDrawer).catch(function () {});

    document.querySelectorAll('[data-cart-icon]').forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
    document.querySelectorAll('[data-cart-overlay]').forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
    document.addEventListener('keydown', function (e) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCartDrawer();
    });

    document.body.addEventListener('click', function (e) {
      var sizeChip = e.target.closest('[data-size-chip]');
      if (sizeChip) {
        if (sizeChip.disabled) return;
        var sizePanel = sizeChip.closest('.product-card__hover-panel');
        if (sizePanel) {
          sizePanel.querySelectorAll('[data-size-chip]').forEach(function (chip) { chip.classList.remove('is-selected'); });
          sizeChip.classList.add('is-selected');
          var linkedQuickAdd = sizePanel.querySelector('[data-quick-add]');
          if (linkedQuickAdd) linkedQuickAdd.dataset.variantId = sizeChip.dataset.variantId;
          var sizeHint = sizePanel.querySelector('[data-size-hint]');
          if (sizeHint) sizeHint.textContent = '';
        }
        return;
      }

      var quickAddBtn = e.target.closest('[data-quick-add]');
      if (quickAddBtn) {
        e.preventDefault();
        if (quickAddBtn.dataset.requiresSize === 'true' && !quickAddBtn.dataset.variantId) {
          var panel = quickAddBtn.closest('.product-card__hover-panel');
          var hint = panel && panel.querySelector('[data-size-hint]');
          if (hint) hint.textContent = 'Select a size first';
          if (panel && panel.animate) {
            panel.animate(
              [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
              { duration: 250 }
            );
          }
          return;
        }
        addToCart(quickAddBtn.dataset.variantId, 1, e, { openDrawer: false });
        return;
      }

      var toastViewBtn = e.target.closest('[data-quick-add-toast-view]');
      if (toastViewBtn) {
        hideQuickAddToast();
        openCartDrawer();
        return;
      }

      var decreaseBtn = e.target.closest('[data-cart-qty-decrease]');
      var increaseBtn = e.target.closest('[data-cart-qty-increase]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (decreaseBtn || increaseBtn) {
        var key = (decreaseBtn || increaseBtn).dataset.lineKey;
        var line = document.querySelector('[data-cart-line][data-line-key="' + key + '"]');
        var qtyEl = line && line.querySelector('[data-cart-qty-value]');
        var current = qtyEl ? Number(qtyEl.textContent) : 1;
        changeLineQuantity(key, decreaseBtn ? Math.max(0, current - 1) : current + 1);
      }
      if (removeBtn) changeLineQuantity(removeBtn.dataset.lineKey, 0);

      var discountBtn = e.target.closest('[data-discount-apply]');
      if (discountBtn) {
        var wrap = discountBtn.closest('.cart-discount');
        var input = wrap && wrap.querySelector('[data-discount-input]');
        if (input) applyDiscountCode(input.value, input.dataset.discountRedirect);
      }
    });

    document.body.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-discount-input]')) return;
      e.preventDefault();
      applyDiscountCode(e.target.value, e.target.dataset.discountRedirect);
    });

    window.NuviCart = { addToCart: addToCart, openDrawer: openCartDrawer, closeDrawer: closeCartDrawer, applyDiscountCode: applyDiscountCode };
  }

  /* ======================================================
     10. PRODUCT FORM
     ====================================================== */
  function initProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var jsonScript = document.querySelector('[data-product-json]');
    if (!jsonScript) return;
    var product;
    try { product = JSON.parse(jsonScript.textContent); } catch (err) { return; }

    var optionSelectors = form.querySelectorAll('[data-option-index]');
    var hiddenVariantInput = form.querySelector('[data-product-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-to-cart-label]');
    var buyNowBtn = form.querySelector('[data-buy-now]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var qtyInput = form.querySelector('[data-qty-input]');

    var selectedOptions = product.options.map(function (_, i) {
      var selectedBtn = form.querySelector('[data-option-index="' + i + '"] .is-selected');
      return selectedBtn ? selectedBtn.dataset.value : product.variants[0].options[i];
    });

    function findVariant() {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();

      optionSelectors.forEach(function (group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var isSelected = btn.dataset.value === selectedOptions[index];
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-pressed', String(isSelected));
        });
        var selectedLabel = group.querySelector('[data-option-selected-label]');
        if (selectedLabel) selectedLabel.textContent = selectedOptions[index];
      });

      if (!variant) {
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (buyNowBtn) buyNowBtn.setAttribute('disabled', 'disabled');
        return;
      }

      if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price > variant.price) {
          priceWas.textContent = formatMoney(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }

      var available = variant.available;
      if (addBtn) addBtn.toggleAttribute('disabled', !available);
      if (buyNowBtn) buyNowBtn.toggleAttribute('disabled', !available);
      if (addLabel) addLabel.textContent = available ? 'Add to Bag' : 'Sold out';

      if (variant.featured_image) {
        var gallery = document.querySelector('[data-product-gallery]');
        if (gallery) {
          var slide = Array.prototype.filter.call(gallery.querySelectorAll('[data-gallery-slide]'), function (s) {
            var img = s.querySelector('img');
            return img && variant.featured_image.src && img.src.indexOf(variant.featured_image.src.split('?')[0].split('/').pop().split('.')[0]) > -1;
          })[0];
          if (slide) {
            gallery.querySelectorAll('[data-gallery-slide]').forEach(function (s) { s.classList.remove('is-active'); });
            slide.classList.add('is-active');
          }
        }
      }

      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      var group = btn.closest('[data-option-index]');
      var index = Number(group.dataset.optionIndex);
      selectedOptions[index] = btn.dataset.value;
      updateUI();
    });

    var decreaseBtn = form.querySelector('[data-qty-decrease]');
    var increaseBtn = form.querySelector('[data-qty-increase]');
    decreaseBtn && decreaseBtn.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); });
    increaseBtn && increaseBtn.addEventListener('click', function () { if (qtyInput) qtyInput.value = Number(qtyInput.value) + 1; });

    // Size guide click handling now lives in initSizeGuide() (a real modal).

    var gallerySlides = document.querySelectorAll('[data-gallery-slide]');
    var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
    var galleryCounter = document.querySelector('[data-gallery-counter]');

    function setActiveSlide(idx) {
      idx = String(idx);
      gallerySlides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === idx); });
      galleryThumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.index === idx); });
      if (galleryCounter) galleryCounter.textContent = (Number(idx) + 1) + ' / ' + gallerySlides.length;
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { setActiveSlide(thumb.dataset.index); });
    });

    if (gallerySlides.length > 1) {
      document.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = Number(document.querySelector('[data-gallery-slide].is-active').dataset.index);
          var direction = btn.hasAttribute('data-gallery-next') ? 1 : -1;
          var next = (current + direction + gallerySlides.length) % gallerySlides.length;
          setActiveSlide(next);
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = findVariant();
      if (!variant || !window.NuviCart) return;
      var qty = qtyInput ? Number(qtyInput.value) : 1;
      window.NuviCart.addToCart(variant.id, qty, e);
    });

    buyNowBtn && buyNowBtn.addEventListener('click', function (e) {
      var variant = findVariant();
      if (!variant || !window.NuviCart) return;
      var qty = qtyInput ? Number(qtyInput.value) : 1;
      window.NuviCart.addToCart(variant.id, qty, e).then(function () {
        window.location.href = '/checkout';
      });
    });

    updateUI();
  }

  /* ======================================================
     11. COLLECTION FILTERS / SORT
     ====================================================== */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var openBtn = document.querySelector('[data-filter-drawer-open]');
    var closeBtns = document.querySelectorAll('[data-filter-drawer-close]');
    if (!drawer || !openBtn) return;
    openBtn.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; }); });
  }
  function initAccountGate() {
    var overlay = document.querySelector('[data-account-overlay]');
    var gate = document.querySelector('[data-account-gate]');
    var openBtns = document.querySelectorAll('[data-account-open]');
    var closeBtns = document.querySelectorAll('[data-account-close]');
    if (!gate || !openBtns.length) return;

    function openGate() {
      overlay.hidden = false;
      gate.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        gate.classList.add('is-open');
      });
      gate.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = gate.querySelector('[data-account-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeGate() {
      overlay.classList.remove('is-open');
      gate.classList.remove('is-open');
      gate.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (overlay) overlay.hidden = true;
        gate.hidden = true;
      }, 320);
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openGate); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeGate); });
    if (overlay) overlay.addEventListener('click', closeGate);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gate.classList.contains('is-open')) closeGate();
    });
  }
  function initProductCardSwatches() {
    // Hovering a colour dot under a product card swaps the primary photo to
    // that variant's own image (data-swatch-image, set in
    // nuvi-product-card.liquid); moving away restores the card's default
    // featured image (data-default-src on the <img> itself).
    document.querySelectorAll('[data-color-swatches]').forEach(function (row) {
      var card = row.closest('.product-card');
      var img = card && card.querySelector('.product-card__image--primary');
      if (!img) return;
      row.querySelectorAll('.product-card__swatch').forEach(function (swatch) {
        var swatchImage = swatch.dataset.swatchImage;
        if (!swatchImage) return;
        swatch.addEventListener('mouseenter', function () { img.src = swatchImage; });
        swatch.addEventListener('mouseleave', function () { img.src = img.dataset.defaultSrc; });
      });
    });
  }

  function initClientFilters() {
    // Fully client-side filtering across Availability, Price, Category, Size
    // and Colour — driven entirely by data-* attributes on each product card
    // (see main-collection-product-grid.liquid), no Search & Discovery app
    // config required. The filters snippet is rendered twice (desktop
    // sidebar + mobile drawer); `mirror()` keeps both copies of the form in
    // sync so switching between them doesn't lose the selection.
    var forms = document.querySelectorAll('[data-filters-form]');
    if (!forms.length) return;
    var cards = document.querySelectorAll('[data-product-filter]');
    if (!cards.length) return;

    function key(input) {
      return input.dataset.filterGroup + ':' + (input.value || '');
    }

    function mirror(source) {
      // Sync checked/value state onto the matching input in the *other*
      // rendered copy of the form (desktop sidebar vs mobile drawer). Visual
      // "is-selected" styling is handled separately in syncChipStyles(),
      // which runs for every input in every form — including the one the
      // user actually clicked — so a swatch/chip always reflects its own
      // state instead of relying on being "the other" element.
      var k = key(source);
      forms.forEach(function (form) {
        form.querySelectorAll('[data-filter-input]').forEach(function (input) {
          if (input === source || key(input) !== k) return;
          if (input.type === 'checkbox') {
            input.checked = source.checked;
          } else {
            input.value = source.value;
          }
        });
      });
    }

    function syncChipStyles() {
      document.querySelectorAll('.filter-chip, .filter-swatch').forEach(function (label) {
        var input = label.querySelector('[data-filter-input]');
        if (input) label.classList.toggle('is-selected', input.checked);
      });
    }

    function collect(group) {
      var values = [];
      forms[0].querySelectorAll('[data-filter-group="' + group + '"]:checked').forEach(function (el) {
        values.push(el.value);
      });
      return values;
    }

    function apply() {
      var available = forms[0].querySelector('[data-filter-group="available"]');
      var wantAvailable = available && available.checked;
      var priceMinEl = forms[0].querySelector('[data-filter-group="price-min"]');
      var priceMaxEl = forms[0].querySelector('[data-filter-group="price-max"]');
      var priceMin = priceMinEl && priceMinEl.value !== '' ? parseFloat(priceMinEl.value) * 100 : null;
      var priceMax = priceMaxEl && priceMaxEl.value !== '' ? parseFloat(priceMaxEl.value) * 100 : null;
      var types = collect('type');
      var sizes = collect('size');
      var colors = collect('color');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var ok = true;
        if (wantAvailable && card.dataset.available !== '1') ok = false;
        if (ok && priceMin !== null && parseFloat(card.dataset.price) < priceMin) ok = false;
        if (ok && priceMax !== null && parseFloat(card.dataset.price) > priceMax) ok = false;
        if (ok && types.length && types.indexOf(card.dataset.type) === -1) ok = false;
        if (ok && sizes.length) {
          var cardSizes = (card.dataset.sizes || '').split(' ');
          if (!sizes.some(function (s) { return cardSizes.indexOf(s) !== -1; })) ok = false;
        }
        if (ok && colors.length) {
          var cardColors = (card.dataset.colors || '').split(' ');
          if (!colors.some(function (c) { return cardColors.indexOf(c) !== -1; })) ok = false;
        }
        card.style.display = ok ? '' : 'none';
        if (ok) visibleCount++;
      });

      document.querySelectorAll('[data-filters-empty]').forEach(function (msg) {
        msg.hidden = visibleCount !== 0;
      });

      syncChipStyles();
    }

    forms.forEach(function (form) {
      form.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () { mirror(input); apply(); });
        if (input.type === 'number') {
          input.addEventListener('input', function () { mirror(input); apply(); });
        }
      });
      var clearBtn = form.querySelector('[data-filters-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          forms.forEach(function (f) {
            f.querySelectorAll('[data-filter-input]').forEach(function (input) {
              if (input.type === 'checkbox') {
                input.checked = false;
              } else {
                input.value = '';
              }
            });
          });
          apply();
        });
      }
    });

    apply();
  }
  function initSortForm() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* ======================================================
     12. CAROUSELS (reviews + category rail)
     ====================================================== */
  function initReviewsCarousel() {
    document.querySelectorAll('[data-reviews-carousel]').forEach(function (carousel) {
      var cards = carousel.querySelectorAll('[data-review-card]');
      var dots = carousel.parentElement.querySelectorAll('[data-reviews-dot]');
      var prevBtn = carousel.parentElement.querySelector('[data-reviews-prev]');
      var nextBtn = carousel.parentElement.querySelector('[data-reviews-next]');
      if (cards.length <= 1) return;
      var index = 0, timer;
      function show(i) {
        index = (i + cards.length) % cards.length;
        cards.forEach(function (c, idx) { c.classList.toggle('is-active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      function next() { show(index + 1); }
      function restart() { clearInterval(timer); timer = setInterval(next, 6000); }
      prevBtn && prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
      nextBtn && nextBtn.addEventListener('click', function () { show(index + 1); restart(); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });
      restart();
    });
  }
  function initStoreLocatorCarousel() {
    document.querySelectorAll('[data-store-carousel]').forEach(function (carousel) {
      var photos = carousel.querySelectorAll('[data-store-photo]');
      var dots = carousel.querySelectorAll('[data-store-dot]');
      if (photos.length <= 1) return;
      var index = 0;
      function show(i) {
        index = (i + photos.length) % photos.length;
        photos.forEach(function (p, idx) { p.classList.toggle('is-active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      setInterval(function () { show(index + 1); }, 4000);
    });
  }
  function initCategoryOrbit() {
    document.querySelectorAll('.category-orbit').forEach(function (section) {
      var rail = section.querySelector('[data-orbit-rail]');
      var prevBtn = section.querySelector('[data-orbit-prev]');
      var nextBtn = section.querySelector('[data-orbit-next]');
      if (!rail) return;
      prevBtn && prevBtn.addEventListener('click', function () { rail.scrollBy({ left: -240, behavior: 'smooth' }); });
      nextBtn && nextBtn.addEventListener('click', function () { rail.scrollBy({ left: 240, behavior: 'smooth' }); });
    });
  }

  /* ======================================================
     13. WISHLIST (client-side, localStorage — no app required)
     ====================================================== */
  var WISHLIST_KEY = 'nuvi:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('nuvi:wishlist-change', { detail: { items: items } }));
  }

  function toggleWishlist(productId, productHandle, originEl) {
    var items = getWishlist();
    var exists = items.some(function (item) { return String(item.id) === String(productId); });
    if (exists) {
      items = items.filter(function (item) { return String(item.id) !== String(productId); });
    } else {
      items.push({ id: productId, handle: productHandle, addedAt: Date.now() });
    }
    setWishlist(items);
    if (originEl && !exists) {
      originEl.classList.add('is-bouncing');
      setTimeout(function () { originEl.classList.remove('is-bouncing'); }, 400);
    }
    return !exists;
  }

  function refreshWishlistButtons() {
    var items = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.dataset.productId;
      var active = items.some(function (item) { return String(item.id) === String(id); });
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.classList.toggle('is-hidden', items.length === 0);
    });
  }

  function buildWishlistCard(product) {
    var a = document.createElement('a');
    a.href = '/products/' + product.handle;
    a.className = 'product-card';
    var image = product.featured_image
      ? '<img class="product-card__image product-card__image--primary" src="' + product.featured_image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="600" height="600" loading="lazy">'
      : '<div class="wishlist-card__placeholder"></div>';
    var price = formatMoney(product.price);
    a.innerHTML =
      '<div class="product-card__media">' + image + '</div>' +
      '<div class="product-card__info"><div><span class="product-card__title">' + product.title + '</span></div>' +
      '<div class="product-card__price"><span class="nuvi-price__now">' + price + '</span></div></div>';
    return a;
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var items = getWishlist();
    var emptyState = document.querySelector('[data-wishlist-empty]');

    if (items.length === 0) {
      grid.hidden = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;

    grid.innerHTML = '';
    items.forEach(function (item) {
      if (!item.handle) return;
      fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return;
          grid.appendChild(buildWishlistCard(product));
        })
        .catch(function () {});
    });
  }

  function initWishlist() {
    refreshWishlistButtons();
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn.dataset.productId, btn.dataset.productHandle, btn);
      refreshWishlistButtons();
    });
    document.addEventListener('nuvi:wishlist-change', refreshWishlistButtons);
    renderWishlistPage();
  }

  /* ======================================================
     14. STICKY ADD TO CART (product page)
     ====================================================== */
  function initStickyAddToCart() {
    var bar = document.querySelector('[data-sticky-atc]');
    var trigger = document.querySelector('[data-add-to-cart]');
    if (!bar || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Only show the sticky bar once the real button has scrolled ABOVE
        // the viewport (boundingClientRect.top < 0) — not merely whenever
        // it's off-screen, which is also true before the user has scrolled
        // down to it yet (e.g. right on page load).
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        document.body.classList.toggle('has-sticky-atc', scrolledPast);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    observer.observe(trigger);

    var stickyBtn = bar.querySelector('[data-sticky-add-to-cart]');
    stickyBtn && stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.getElementById('ProductForm');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ======================================================
     15. RECENTLY VIEWED PRODUCTS
     ====================================================== */
  var RECENTLY_VIEWED_KEY = 'nuvi:recently-viewed';
  var MAX_RECENTLY_VIEWED = 12;

  function trackRecentlyViewed() {
    var jsonScript = document.querySelector('[data-product-json]');
    if (!jsonScript) return;
    var product;
    try { product = JSON.parse(jsonScript.textContent); } catch (e) { return; }
    if (!product || !product.handle) return;

    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) {}
    list = list.filter(function (h) { return h !== product.handle; });
    list.unshift(product.handle);
    list = list.slice(0, MAX_RECENTLY_VIEWED);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
  }

  function renderRecentlyViewed() {
    var rail = document.querySelector('[data-recently-viewed-rail]');
    if (!rail) return;
    var currentHandle = null;
    var jsonScript = document.querySelector('[data-product-json]');
    if (jsonScript) {
      try { currentHandle = JSON.parse(jsonScript.textContent).handle; } catch (e) {}
    }

    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) {}
    list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 8);

    var section = rail.closest('[data-recently-viewed-section]');
    if (list.length === 0) {
      if (section) section.hidden = true;
      return;
    }
    if (section) section.hidden = false;

    rail.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return;
          rail.appendChild(buildWishlistCard(product));
        })
        .catch(function () {});
    });
  }

  /* ======================================================
     16. SIZE GUIDE MODAL
     ====================================================== */
  function initSizeGuide() {
    var trigger = document.querySelector('[data-size-guide]');
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!trigger || !modal) return;

    var closeBtns = modal.querySelectorAll('[data-size-guide-close]');
    var overlay = modal.querySelector('[data-size-guide-overlay]');

    function open() {
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 300);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ======================================================
     17. PRODUCT RECOMMENDATIONS (Shopify's real recommendation API)
     ====================================================== */
  function initRecommendations() {
    var container = document.querySelector('[data-recommendations]');
    if (!container || !container.dataset.url) return;

    fetch(container.dataset.url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(container.id);
        if (fresh && fresh.querySelector('.product-card')) {
          container.innerHTML = fresh.innerHTML;
        } else if (!container.querySelector('.product-card')) {
          // Neither the fallback nor the real recommendations produced
          // anything (e.g. brand new store, no order history yet) — hide
          // the empty "You may also like" heading rather than show nothing.
          var wrap = container.closest('.related-products');
          if (wrap) wrap.hidden = true;
        }
      })
      .catch(function () {});
  }

  /* ======================================================
     SITEWIDE POPUPS (sale popup + corner signup)
     ====================================================== */
  var POPUP_DAY_MS = 24 * 60 * 60 * 1000;

  function popupStorageKey(id) { return 'nuviPopupLastShown_' + id; }

  function popupShouldShow(id, frequency) {
    if (frequency === 'always') return true;
    var key = popupStorageKey(id);
    if (frequency === 'day') {
      var last = Number(window.localStorage.getItem(key) || 0);
      return !last || (Date.now() - last) > POPUP_DAY_MS;
    }
    // default: once per browser session
    return !window.sessionStorage.getItem(key);
  }

  function popupMarkShown(id, frequency) {
    var key = popupStorageKey(id);
    if (frequency === 'day') {
      window.localStorage.setItem(key, String(Date.now()));
    } else if (frequency !== 'always') {
      window.sessionStorage.setItem(key, '1');
    }
  }

  function openPromoPopup(popup) {
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }

  function closePromoPopup(popup) {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { popup.hidden = true; }, 300);
  }

  function initPromoPopup() {
    var popup = document.querySelector('[data-promo-popup]');
    if (!popup) return;

    var frequency = popup.dataset.promoFrequency || 'session';
    var delay = Number(popup.dataset.promoDelay || 0);
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile && popup.dataset.promoMobile === 'false') return;
    if (!isMobile && popup.dataset.promoDesktop === 'false') return;
    if (!popupShouldShow('promo', frequency)) return;

    setTimeout(function () {
      openPromoPopup(popup);
      popupMarkShown('promo', frequency);
    }, delay);

    popup.querySelectorAll('[data-promo-close]').forEach(function (el) {
      el.addEventListener('click', function () { closePromoPopup(popup); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePromoPopup(popup);
    });
  }

  function initCornerSignup() {
    var box = document.querySelector('[data-corner-signup]');
    if (!box) return;

    var frequency = box.dataset.popupFrequency || 'day';
    var delay = Number(box.dataset.popupDelay || 0);

    if (!popupShouldShow('cornerSignup', frequency)) return;

    setTimeout(function () {
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      popupMarkShown('cornerSignup', frequency);
    }, delay);

    var closeBtn = box.querySelector('[data-corner-signup-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        box.classList.remove('is-open');
        setTimeout(function () { box.hidden = true; }, 300);
      });
    }
  }

  function initUgcGallery() {
    var rows = document.querySelectorAll('[data-ugc-row]');
    if (!rows.length) return;

    // Rows with more videos than fit in one row (data-ugc-rail) scroll
    // horizontally instead of wrapping. Wire up the prev/next arrows and
    // hide the nav row entirely when the rail doesn't actually overflow
    // at the current viewport width (e.g. a wide desktop window).
    document.querySelectorAll('.ugc-gallery').forEach(function (section) {
      var rail = section.querySelector('[data-ugc-rail]');
      var nav = section.querySelector('[data-ugc-nav]');
      var prevBtn = section.querySelector('[data-ugc-prev]');
      var nextBtn = section.querySelector('[data-ugc-next]');
      if (!rail || !nav) return;

      var scrollStep = function () {
        var tile = rail.querySelector('.ugc-tile');
        return tile ? tile.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
      };
      prevBtn && prevBtn.addEventListener('click', function () { rail.scrollBy({ left: -scrollStep(), behavior: 'smooth' }); });
      nextBtn && nextBtn.addEventListener('click', function () { rail.scrollBy({ left: scrollStep(), behavior: 'smooth' }); });

      var syncNavVisibility = function () {
        var overflowing = rail.scrollWidth > rail.clientWidth + 1;
        nav.classList.toggle('is-hidden', !overflowing);
      };
      syncNavVisibility();
      window.addEventListener('resize', syncNavVisibility);
    });

    var videos = [];
    rows.forEach(function (row) {
      row.querySelectorAll('.ugc-tile__video').forEach(function (el) {
        if (el.tagName === 'VIDEO') videos.push(el);
      });
    });

    if (videos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      videos.forEach(function (video) { observer.observe(video); });
    }

    rows.forEach(function (row) {
      row.querySelectorAll('[data-ugc-mute]').forEach(function (btn) {
        var tile = btn.closest('.ugc-tile');
        var video = tile && tile.querySelector('.ugc-tile__video');
        if (!video || video.tagName !== 'VIDEO') return;
        btn.addEventListener('click', function () {
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        });
      });
    });

    // Swap the heading to reference the active festival (using the same
    // FESTIVALS data + nuvi:festival-change event the announcement bar and
    // festival FX already use), and restore the default once it ends.
    var headings = document.querySelectorAll('[data-ugc-heading]');
    if (headings.length) {
      var applyUgcHeading = function (festival) {
        headings.forEach(function (heading) {
          if (festival) {
            var template = heading.dataset.ugcHeadingTemplate || '{festival}';
            heading.textContent = template
              .replace('{festival}', festival.label)
              .replace('{emoji}', festival.emoji || '');
          } else {
            heading.textContent = heading.dataset.ugcHeadingDefault || heading.textContent;
          }
        });
      };

      // Pick up whatever festival state initFestivals() already applied to
      // <html> before this runs, so a festival active on first load shows
      // immediately (not just on the next festival-change event).
      applyUgcHeading(findFestival(document.documentElement.dataset.festival));
      document.addEventListener('nuvi:festival-change', function (e) {
        applyUgcHeading(e.detail.festival);
      });
    }
  }

  /* ======================================================
     BOOTSTRAP
     ====================================================== */
  function bootstrap() {
    ready(function () {
      initDayNight();
      initFestivalFxListener();
      initFestivals();
      initGlobalStars();
      initHeroSky();
      initStickyHeader();
      initMegaMenu();
      initMobileMenu();
      initFooterAccordions();
      initScrollJourney();
      initAnnouncementBar();
      initHeroSlider();
      initHeroSlideLinks();
      initCart();
      initProductForm();
      initFilterDrawer();
      initAccountGate();
      initClientFilters();
      initProductCardSwatches();
      initSortForm();
      initReviewsCarousel();
      initStoreLocatorCarousel();
      initCategoryOrbit();
      initWishlist();
      initStickyAddToCart();
      initSizeGuide();
      trackRecentlyViewed();
      renderRecentlyViewed();
      initRecommendations();
      initPromoPopup();
      initCornerSignup();
      initUgcGallery();
    });
  }

  /* In a real browser (no `module`), boot immediately — identical to the
     previous behavior. Under Node/CommonJS (unit tests), skip auto-boot
     and export just the testable pieces instead. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      computeStickyHeaderTop: computeStickyHeaderTop,
      isPastScrollThreshold: isPastScrollThreshold,
      initStickyHeader: initStickyHeader
    };
  } else {
    bootstrap();
  }
})();
